import DataTable from 'datatables.net-react';
import $ from 'jquery';
import { jsPDF } from "jspdf";
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { CSVLink } from 'react-csv';
import { LedgerServices } from '../../services/LedgerServices';
import * as BullCache from "../../util/BullCache";
import '../custom.css';
import ReactDOMServer from 'react-dom/server';
import NumberFormatter from "../components/NumberFormatter";
import { isMobile } from '../../util/GeneralUtil';

function Ledger() {
  const [loading, setLoading] = useState(false);
  const [ledger, setLedger] = useState([]);
  const [filteredLedger, setFilteredLedger] = useState([]);
  const [showZeroAmount, setShowZeroAmount] = useState(false);

  var user = BullCache.getFromCache("user");
  const request = {
    adminId: user.adminId,
    withZero: showZeroAmount,
  };

  const handleSubmit = () => {
    setLoading(true);
    LedgerServices.getLedger(request).then(res => {
      setLoading(false);
      if (res.code === 1 && res.data.ledgers.length > 0) {
        setLedger(res.data.ledgers);
        filterLedger(res.data.ledgers, showZeroAmount);
      } else {
        filterLedger([]);
      }
    });
  };

  const filterLedger = (data, showZero) => {
    if (showZero) {
      setFilteredLedger(data);
    } else {
      const nonZeroLedger = data.filter(entry => entry.amount !== 0);
      setFilteredLedger(nonZeroLedger);
    }
  };

  const handleCheckboxChange = (event) => {
    setShowZeroAmount(event.target.checked);
  };

  useEffect(() => {
    handleSubmit();
  }, []);

  const columns = [
    {
      data: 'firstName',
      render: function (data, type, row) {
        let adminTypeAbbr = '';
        if (row.adminType === 'ADMIN') {
          adminTypeAbbr = 'A';
        } else if (row.adminType === 'MASTER') {
          adminTypeAbbr = 'M';
        } else if (row.adminType === 'BROKER') {
          adminTypeAbbr = 'B';
        } else if (row.adminType === 'SUBBROKER') {
          adminTypeAbbr = 'B';
        } else if (row.adminType === null) {
          adminTypeAbbr = 'C';
        }
        return row.userName ?  `${row.firstName} (${row.userName})  (${adminTypeAbbr})` : `${row.firstName}`;
      },
      className: 'text-start fss-09',
    },
    {
      data: 'amount',
      title: 'BALANCE',
      className: 'text-end fss-09',
    },
  ];

  const data = filteredLedger.map((sr, index) => ({
    firstName: sr.firstName,
    adminType: sr.adminType,
    userName: sr.userName, 
    adminId: sr.adminId,
    userid: sr.userid,
    amount: ReactDOMServer.renderToString(<NumberFormatter number={sr.amount} />)
  }));

  const headers = [
    { label: 'Name', key: 'fullName' },
    { label: 'Balance', key: 'amount' }
  ];

  const prepareDataForCSV = (data) => {
    return data.map((entry) => ({
      fullName: `${entry.firstName} (${entry.userName})`,
      amount: entry.amount,
    }));
  };

  const getCurrentDate = () => {
    const date = new Date();

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const exportToPDF = () => {
    const doc = new jsPDF();

    const currentDate = getCurrentDate();

    doc.setFontSize(12);
    doc.text('Ledger', 100, 25);

    doc.setFontSize(12);
    doc.text(currentDate, 170, 25);

    const startY = 35;
    let currentY = startY;

    const marginLeft = 20;
    const columnWidth = 100;
    const tableWidth = 180;
    const rightAlignX = marginLeft + columnWidth + 80;
    const headerBackgroundColor = [44, 62, 80];

    doc.setFillColor(...headerBackgroundColor);
    doc.rect(marginLeft - 5, currentY - 5, columnWidth + 90, 7, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);

    doc.text('Name', marginLeft, currentY);
    doc.text('Balance', rightAlignX, currentY, { align: 'right' });
    doc.setTextColor(0, 0, 0);
    doc.line(marginLeft, currentY + 2, marginLeft + tableWidth, currentY + 2);
    currentY += 10;

    filteredLedger.forEach((entry) => {

      doc.text(`${entry.firstName} (${entry.userName})`, marginLeft, currentY);
      doc.text(entry.amount.toString(), rightAlignX, currentY, { align: 'right' });

      doc.line(marginLeft, currentY + 5, marginLeft + tableWidth, currentY + 5);

      currentY += 10;
    });
    doc.line(marginLeft, currentY - 2, marginLeft + tableWidth, currentY - 2);

    doc.save('Ledger.pdf');
  };


  const filename = `Ledger_(${getCurrentDate()}).csv`;

const options = {
  rowCallback: function (row, data) {
    if (data.adminType === 'MASTER') {
      $(row).addClass('master-row');
    } else if (data.adminType === 'ADMIN') {
      $(row).addClass('customer-row');
    } else if (data.adminType === 'BROKER' || data.adminType === 'SUBBROKER') {
      $(row).addClass('broker-row');
    } else if (data.adminType === 'Upline') {
      $(row).addClass('bg-secondary-row2');
    } else {
      $(row).addClass('customer-row');
    }

    $(row).css('cursor', 'pointer');
    $(row).on('click', function () {
      let navigateUrl = '/account';
      if (data.adminType === null) {
        navigateUrl += `?userid=${data.userid}`;
      } else {
        navigateUrl += `?adminId=${data.adminId}`;
      }
      //window.location.href = navigateUrl;
      window.open(navigateUrl, '_blank');
    });
  },
};

// Conditionally add language and dom options for mobile
if (isMobile) {
  options.language = {
    emptyTable: 'No Data Found',
    lengthMenu: '_MENU_',
  };
  options.dom = '<"datatable-toolbar"lf>rtip';
}

  return (
    <Card>
      <Card.Body className='ps-1 pe-1 mb-4'>
        <Row>
          <Col xl={5} className={`text-start`}>
            <div className={`form-check checkbox-lg ${isMobile ? "d-flex" : ""}`}>
              <input
                className="form-check-input mt-2"
                type="checkbox"
                value="5"
                checked={showZeroAmount}
                onChange={handleCheckboxChange}
                id="checkbox-3"
                name="check1"
              />
              <label className="form-check-label me-2" htmlFor="checkbox-3">
                <b className='fss-05'> SHOW ZERO LEDGER ACCOUNT(S)</b>
              </label>
              <Button variant="success" size={isMobile ? "sm" : undefined} className='fss-07 fw-bold me-2' onClick={handleSubmit}>Submit</Button>

              <CSVLink
                data={prepareDataForCSV(filteredLedger)}
                headers={headers}
                filename={filename}
                className={`btn btn-secondary fss-07 fw-bold btn-md me-2 ${isMobile ? 'btn-sm' : 'btn-md'}`}
              > CSV
              </CSVLink>
              <Button variant="secondary" size={isMobile ? "sm" : undefined} className='fss-07 fw-bold' onClick={exportToPDF}>PDF</Button>
            </div>
          </Col>
        </Row>
        <div className="table-responsive">
          {loading ? (
            <div className="container vh-100">
              <div className="d-flex align-items-center justify-content-center h-90">
                <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={data}
              className="mt-1 table bg-secondary-row2 table page-wrapper"
              id="Did"
              options={options}
            >
              <thead>
                <tr>
                  <th>NAME</th>
                  <th className="text-end col-4">BALANCE</th>
                </tr>
              </thead>
            </DataTable>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default Ledger;
